// Battery strip: charge, voltage and current for one pack at a time, slaved to
// the profile. On a dual-battery aircraft a 1/2 toggle (left of the trace)
// switches packs; on a single-battery one it is hidden.

import { Strip } from './strip.js';

const PACKS = {
  1: [
    { id: 'charge', key: 'batteryPercent', label: 'charge', unit: '%', colour: 'var(--trace)', min: 0, max: 100, dash: '3 3', opacity: 0.8, fmt: (v) => `${Math.round(v)}` },
    { id: 'voltage', key: 'batteryVoltageV', label: 'voltage', unit: 'V', colour: 'var(--ok)', opacity: 0.9, fmt: (v) => v.toFixed(1) },
    { id: 'current', key: 'batteryCurrentA', label: 'current', unit: 'A', colour: 'var(--amber)', opacity: 0.9, fmt: (v) => v.toFixed(1) },
  ],
  2: [
    { id: 'charge', key: 'battery2Percent', label: 'charge', unit: '%', colour: 'var(--trace)', min: 0, max: 100, dash: '3 3', opacity: 0.8, fmt: (v) => `${Math.round(v)}` },
    { id: 'voltage', key: 'battery2VoltageV', label: 'voltage', unit: 'V', colour: 'var(--ok)', opacity: 0.9, fmt: (v) => v.toFixed(1) },
    { id: 'current', key: 'battery2CurrentA', label: 'current', unit: 'A', colour: 'var(--amber)', opacity: 0.9, fmt: (v) => v.toFixed(1) },
  ],
};

export class BatteryChart extends Strip {
  storageKey() { return 'ddlv-battery-series'; }
  ariaLabel() { return 'Battery timeline'; }

  isDual() { return this.flight.meta.batteryCount >= 2 && this.flight.has('battery2Percent'); }

  series() { return PACKS[this.pack || 1]; }

  leftExtras() {
    if (!this.isDual()) return '';
    const p = this.pack || 1;
    return `<div class="pack-toggle" role="group" aria-label="Battery pack">
        <button type="button" data-pack="1" class="${p === 1 ? 'on' : ''}" aria-pressed="${p === 1}"><i class="fa-light fa-battery-full"></i>1</button>
        <button type="button" data-pack="2" class="${p === 2 ? 'on' : ''}" aria-pressed="${p === 2}"><i class="fa-light fa-battery-full"></i>2</button>
      </div>`;
  }

  bindExtras() {
    this.container.querySelectorAll('[data-pack]').forEach((button) => {
      button.addEventListener('click', () => {
        const next = Number(button.dataset.pack);
        if (next !== (this.pack || 1)) { this.pack = next; this.render(); }
      });
    });
  }
}
